export default __webpack_public_path__ + "static/tablet_sek2_KV13-25f45831a19e7fd60d6691cc65143acb.mp4";